import { render, staticRenderFns } from "./PWmatUpdateFunc.vue?vue&type=template&id=5213434b&scoped=true&"
import script from "./PWmatUpdateFunc.vue?vue&type=script&lang=js&"
export * from "./PWmatUpdateFunc.vue?vue&type=script&lang=js&"
import style0 from "./PWmatUpdateFunc.vue?vue&type=style&index=0&id=5213434b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5213434b",
  null
  
)

component.options.__file = "PWmatUpdateFunc.vue"
export default component.exports